// extracted by mini-css-extract-plugin
export default {"grid":"Integrations_grid__tLldN","card":"Integrations_card__nHIWH"};